const HeroSection = () => {
  return (
    <section id="inicio" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Solid gradient background */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#0F1E2E] via-[#1E3A5F] to-[#0F1E2E]" />
      {/* Subtle diagonal texture overlay */}
      <div className="absolute inset-0 opacity-10"
        style={{ backgroundImage: 'repeating-linear-gradient(135deg, #C8A96A 0px, #C8A96A 1px, transparent 1px, transparent 60px)' }}
      />

      {/* Content */}
      <div className="relative z-10 w-full text-center px-5 md:px-6 max-w-4xl mx-auto pt-24 pb-16">
        {/* H1 */}
        <h1 className="text-4xl md:text-7xl font-bold text-[#F9FAFB] leading-[1.1] mb-5 md:mb-6">
          Advocacia estratégica para{' '}
          <span className="text-[#C8A96A]">decisões seguras</span>
        </h1>

        {/* Subtitle */}
        <p className="text-[#E5E7EB]/80 text-base md:text-xl leading-relaxed mb-10 md:mb-12 max-w-3xl mx-auto font-light">
          Helio de Oliveira &amp; Santos Oliveira Advogados é uma sociedade de advogados com atuação destacada nas áreas do Direito Civil, Família, Sucessões, Imobiliário, Consumidor, Empresarial e Trabalhista com foco na prestação de assessoria jurídica segura, estratégica e orientada à proteção dos interesses de seus clientes.
        </p>

        {/* Single CTA centered */}
        <div className="flex items-center justify-center">
          <a
            href="#contato"
            className="px-10 md:px-14 py-4 bg-[#C8A96A] text-[#0F1E2E] text-xs font-bold tracking-[0.2em] uppercase hover:bg-[#b89558] transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            FALE CONOSCO
          </a>
        </div>

        {/* Stats */}
        <div className="mt-14 md:mt-20 grid grid-cols-3 gap-4 md:gap-8 max-w-2xl mx-auto border-t border-white/10 pt-8 md:pt-10">
          {[
            { num: '8+', label: 'Áreas de Atuação' },
            { num: '15+', label: 'Anos de Experiência' },
            { num: '100%', label: 'Dedicação ao Cliente' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <p className="text-2xl md:text-3xl font-bold text-[#C8A96A] mb-1">{stat.num}</p>
              <p className="text-[#E5E7EB]/60 text-[10px] md:text-xs tracking-wider uppercase">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2">
        <p className="text-[#C8A96A]/50 text-[10px] tracking-[0.3em] uppercase">Role</p>
        <div className="w-px h-12 bg-gradient-to-b from-[#C8A96A]/50 to-transparent" />
      </div>
    </section>
  );
};

export default HeroSection;
